// extracted by mini-css-extract-plugin
export default {"container":"JK-z","topReviewHeading":"KK-z","criticalReview":"LK-z","favorableReview":"MK-z","vsSeparator":"NK-z"};